// plugins/support-chat.client.js
// Picks which chat to show: Front (live agents) when support is open, otherwise
// the in-house AI assistant. Client-only, runs once on the initial page load.
//
// "Open" is decided server-side by /support-status (in-hours AND an agent online
// in Front). On any error we fall back to the AI, which is always on, so there's
// never a moment with no way to get help.

export default async function () {
  const AI_ORIGIN = 'https://teflchatagent.netlify.app'
  // Must match where the router is mounted on the data server.
  const STATUS_URL = process.env.DATA_URL + '/front/support/support-status'
  const FRONT_CHAT_ID = '47c2e4a291225d5ff81f6f4e52b634c4' // from Front → Settings → Chat

  let open = false
  try {
    const res = await fetch(STATUS_URL)
    open = (await res.json()).open === true
  } catch (e) {
    open = false // can't reach the server — fall back to the always-on AI
  }

  open ? loadFront() : loadAi()

  function loadAi() {
    // Set this BEFORE injecting. A dynamically-added script has no
    // document.currentScript, so embed.js can't self-derive its origin and
    // would otherwise fall back to localhost.
    window.__teflWidgetUrl = AI_ORIGIN

    const s = document.createElement('script')
    s.src = AI_ORIGIN + '/embed.js'
    s.defer = true
    document.body.appendChild(s)
  }

  function loadFront() {
    // Standard Front Chat loader: run the bundle, then init once it's ready.
    const s = document.createElement('script')
    s.src = 'https://chat-assets.frontapp.com/v1/chat.bundle.js'
    s.onload = function () {
      window.FrontChat('init', {
        chatId: FRONT_CHAT_ID,
        useDefaultLauncher: true,
      })
    }
    document.body.appendChild(s)
  }
}